<template>
  <v-autocomplete
    v-model="selected"
    :items="filteredItems"
    :label="label"
    :multiple="multiple"
    :chips="multiple"
    :small-chips="multiple"
    :deletable-chips="multiple"
    :search-input.sync="search"
    :dense="dense"
    :outlined="outlined"
    item-value="id"
    item-text="name"
    clearable
    hide-details
    @input="updateQlikSelections"
    @blur="leaveFocus"
    @focus="focus = true"
  >
    <template v-if="multiple" v-slot:selection="{ index }">
      <v-fade-transition>
        <v-chip v-if="selected.length >= 1 && index === 0 && !focus" small>{{selected.length}} {{$tc('Global.Common.selection', selected.length)}}</v-chip>
      </v-fade-transition>
    </template>
  </v-autocomplete>
</template>

<script>
import {generateFilterObjectDef} from '@portal/qlik'
export default {
  name: 'QlikCustomFilter',
  props: {
    qAppId: {type: String, required: true},
    qDimensionId: {type: String, required: true},
    /**
     * Allow multiple selections
     */
    multiple: {type: Boolean, required: false, default: false},
    /**
     * Show excludes values (refer to qlik associative engine states)
     */
    showAll: {type: Boolean, required: false},
    dense: {type: Boolean, required: false, default: false},
    outlined: {type: Boolean, required: false, default: false},
  },
  data: () => ({
    filterObject: null,
    label: '',
    search: '',
    items: [],
    selected: [],
    focus: false
  }),
  computed: {
    enigma () {
      return this.$qlik[this.qAppId].enigmaDoc
    },
    filteredItems () {
      return [...this.items]
        .filter(item => this.showAll || !item.disabled)
        .sort((a, b) => {
          if (a.selected && !b.selected && a.name > b.name && a.disabled && !b.disabled) return -1
          if (!a.selected && b.selected && a.name < b.name && !a.disabled && b.disabled) return 1
          return 0
        })
    }
  },
  watch: {
    async search (value) {
      if(value) {
        await this.filterObject?.searchListObjectFor({qPath: '/qListObjectDef', qMatch: '*' + value + '*'}) 
      } else {
        await this.filterObject?.abortListObjectSearch({qPath: "/qListObjectDef"});
      }
    }
  },
  methods: {
    async init () {
      const layout = await this.filterObject.getLayout()
      this.label = layout.qListObject.qDimensionInfo.title
      await this.fetchData(layout, true)
      
    },
    updateQlikSelections () {
      this.$emit('select', this.selected)
      const toSelect = this.multiple ? this.selected : [this.selected]
      this.filterObject && this.filterObject.selectListObjectValues('/qListObjectDef', toSelect, !this.multiple)
    },
    async fetchData (layout = null, refreshInternalSelections = false) {
      if (!layout) layout = await this.filterObject.getLayout()
      if (!layout.qListObject.qDataPages.length) {
        this.items = []
        return
      }

      this.items = layout.qListObject.qDataPages[0].qMatrix.map(group => ({
        id: group[0].qElemNumber,
        name: group[0].qText,
        selected: group[0].qState === 'S',
        state: group[0].qState,
        disabled: group[0].qState === 'X'
      }))

      if (refreshInternalSelections) {
        this.selected = this.items.filter(item => item.selected).map(item => item.id)
      }
    },
    async listenChange () {
      await this.fetchData(null, !this.search)
    },
    leaveFocus () {
      this.search = null;
      setTimeout(() => this.focus = false, 150)
    }
  },
  async created () {
    const def = generateFilterObjectDef(this.qDimensionId)
    this.filterObject = await this.enigma.createSessionObject(def)
    await this.init()
    this.filterObject.on('changed', this.listenChange)
  },
  beforeDestroy() {
    this.enigma.destroySessionObject(this.filterObject.id)
  }
}
</script>